import { autoinject } from "aurelia-framework";
import { ConfigService, type DataDogConfig } from "../basic/config.service";

@autoinject
export class DataDogService {

    private _version: string;
    private _ddCfg: DataDogConfig;

    constructor(private configService: ConfigService) {
        this._ddCfg = this.configService.config.analytics?.dataDog;
        this._version = this.configService.config.version;
    }

    //Init DataDog
    public init() {
        if (this._ddCfg && this._ddCfg.applicationId && this._ddCfg.clientToken) {
            import("@datadog/browser-rum").then(({ datadogRum }) => {
                datadogRum.init({
                    clientToken: this._ddCfg.clientToken,
                    applicationId: this._ddCfg.applicationId,
                    site: 'datadoghq.eu',
                    service: this._ddCfg.service,
                    env: this._ddCfg.environment,
                    // Specify a version number to identify the deployed version of your application in Datadog 
                    version: this._version,
                    sessionSampleRate: Number(this._ddCfg.sessionSampleRate),
                    sessionReplaySampleRate: Number(this._ddCfg.sessionReplaySampleRate),
                    trackUserInteractions: true,
                    trackResources: true,
                    trackLongTasks: true,
                    allowedTracingUrls: [(url: string) => new URL(url).hostname.endsWith(".rightship.com")],
                    defaultPrivacyLevel: 'mask-user-input'
                })
            });

            import("@datadog/browser-logs").then(({ datadogLogs }) => {
                datadogLogs.init({
                    clientToken: this._ddCfg.clientToken,
                    site: 'datadoghq.eu',
                    forwardErrorsToLogs: true,
                    sessionSampleRate: Number(this._ddCfg.sessionSampleRate),
                    service: this._ddCfg.service,
                    env: this._ddCfg.environment,
                    // Specify a version number to identify the deployed version of your application in Datadog 
                    version: this._version
                })
            });
        }
    }
}